<template>
  <div>
    <div
      :class="cs"
      style="padding:5px;height:100%;width:100%"
      @dblclick="eventClicked"
    >
      <div style="display:grid">
        <div>
          {{ data.customerName }} ({{ data.Status | title }})
          <span v-if="data.balance > 0" class="balance"
            >Balance Due :{{ (data.balance / 100) | currency }}</span
          >
        </div>
        <div>{{ data.Subject }}</div>
        <small>
          {{ data.StartTime | moment("h:mm:ss A") }} -
          {{ data.EndTime | moment("h:mm:ss A") }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: null,
      cs: null,
      id: Math.floor(Math.random() * (10000 - 1 + 1)) + 1,
    };
  },
  methods: {
    eventClicked() {
      this.$emitter.emit("show-appt", this.data.Id);
    },
  },
  created() {
    if (this.data.Status == "COMPLETED" && this.data.balance > 0) {
      this.cs = "e-appointment scheduleDue";
    } else if (this.data.Status == "COMPLETED" && this.data.balance <= 0) {
      this.cs = "e-appointment scheduleCompletePaid";
    } else if (this.data.Status == "SCHEDULED") {
      this.cs = "e-appointment scheduleScheduled";
    } else if (this.data.Status == "CANCELED") {
      this.cs = "e-appointment scheduleCanceled";
    }
  },
};
</script>

<style>
.scheduleDue {
  background-color: #ff6961 !important;
}
.scheduleComplete {
  color: black !important;
  background-color: #dbe8d8 !important;
}

.scheduleComplete .balanceDue {
  color: white !important;
}

.scheduleCanceled {
  color: gray !important;
  background-color: #efefef !important;
}

.scheduleCanceled .balanceDue {
  color: red !important;
}

.scheduleCompletePaid {
  color: black !important;
  background-color: #b1d8b7 !important;
}

.scheduleScheduled {
  color: black !important;
  background-color: #fdfd96 !important;
}
</style>
